// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  width: 50%;
  padding-right: 35px;
}
.form-container .form {
  margin-top: 16px;
}
.form-container .form .form-group {
  padding-top: 24px;
}
.form-container .form .action-btn-wrap {
  padding-top: 32px;
  display: flex;
  justify-content: flex-end;
}
.form-container .form .action-btn-wrap .custom-btn {
  width: 225px;
}
.form-container .form .action-btn-wrap button.custom-btn-primary {
  background-color: rgba(22, 59, 107, 0.8);
  border: solid 1px rgba(22, 59, 107, 0.8);
}
.form-container .form .action-btn-wrap button.custom-btn-primary:hover {
  color: #2E9FC4;
  background-color: #fff;
}

@media only screen and (min-width: 0px) and (max-width: 1024px) {
  .form-container {
    padding-right: 16px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 768px) {
  .form-container {
    width: 100%;
    padding-right: 0;
    padding-top: 40px;
  }
  .form-container .form .action-btn-wrap button.custom-btn-primary {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Form/Form.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,mBAAA;AACF;AAAE;EACE,gBAAA;AAEJ;AADI;EACE,iBAAA;AAGN;AADI;EACE,iBAAA;EACA,aAAA;EACA,yBAAA;AAGN;AAFM;EACE,YAAA;AAIR;AAFM;EACE,wCAAA;EACA,wCAAA;AAIR;AAHQ;EACE,cAAA;EACA,sBAAA;AAKV;;AAEA;EACE;IACE,mBAAA;EACF;AACF;AACA;EACE;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;EACF;EAEM;IACE,WAAA;EAAR;AACF","sourcesContent":[".form-container{ \r\n  width: 50%;\r\n  padding-right: 35px;\r\n  .form{\r\n    margin-top: 16px;\r\n    .form-group{\r\n      padding-top: 24px;\r\n    }\r\n    .action-btn-wrap{\r\n      padding-top: 32px;\r\n      display: flex;\r\n      justify-content: flex-end;\r\n      .custom-btn{\r\n        width: 225px;\r\n      }\r\n      button.custom-btn-primary{\r\n        background-color: #163B6BCC;\r\n        border: solid 1px #163B6BCC;\r\n        &:hover{\r\n          color: #2E9FC4;\r\n          background-color: #fff;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 1024px) {\r\n  .form-container{\r\n    padding-right: 16px;\r\n  }\r\n}\r\n@media only screen and (min-width: 0px) and (max-width: 768px) {\r\n  .form-container{\r\n    width: 100%;\r\n    padding-right: 0;\r\n    padding-top: 40px;\r\n    .form{\r\n      .action-btn-wrap{\r\n        button.custom-btn-primary{\r\n          width: 100%;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
